import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";
import Select from "react-select";
import { withRouter } from "../../utils/withRouter";

class OrderForm extends Component {
  constructor(props) {
    super(props);

    const { id } = props.router.params || {};
    this.isEditMode = Boolean(id);

    this.state = {
      id: id || null,
      customers: [],
      products: [],

      customer_phone: "",
      customer_name: "",
      customer_email: "",
      customer_id: null,

      showSuggestion: false,
      filteredCustomers: [],

      formData: {
        shipping_address: "",
        division_name: "",
        payment_type: "",
        order_status: "Pending",
        payment_status: "Unpaid",
        order_note: "",
        delivery_charge: 0,
        coupon_discount: 0,
        discount: 0,
        items: [
          {
            product_id: "",
            search_text: "",
            quantity: 1,
            price: 0,
            sub_total: 0
          },
        ],
        grand_total: 0,
      },

      errors: {},
    };
  }

  async componentDidMount() {
    await this.fetchCustomers();
    await this.fetchProducts();

    if (this.isEditMode) {
      await this.fetchOrder(this.state.id);
    }
  }

  /** FETCH ORDER IF EDIT MODE **/
  fetchOrder = async (id) => {
    try {
      const res = await axios.get(`/products/orders/${id}`);

      if (res.data.status !== "success") {
        Swal.fire("Error", "Order not found", "error");
        return;
      }

      const order = res.data.data;

      // console.log(order);
      console.log(order[0]);

      this.setState({
        customer_phone: order[0].phone,
        customer_name: order[0].full_name,
        customer_email: order[0].email,
        customer_id: order[0].customer_id,

        formData: {
          ...this.state.formData,
          shipping_address: order[0].shipping_address,
          division_name: order[0].division_name,
          payment_type: order[0].payment_geteway_id,
          order_status: order[0].order_status,
          payment_status: order[0].payment_status,
          order_note: order[0].order_note,
          delivery_charge: order[0].delivery_charge,
          coupon_discount: order[0].coupon_discount,
          discount: order[0].discount,
          grand_total: order[0].grand_total,

          items: order.items.map((it) => ({
            product_id: it.product_id,
            search_text: it.product_name,
            quantity: it.quantity,
            price: it.price,
            sub_total: it.sub_total,
          }))
        }
      });
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to fetch order", "error");
    }
  };

  /** FETCH CUSTOMERS **/
  fetchCustomers = async () => {
    try {
      const res = await axios.get("/customers");
      this.setState({ customers: res.data.data || [] });
    } catch (error) {
      Swal.fire("Error", "Failed to load customers", "error");
    }
  };

  /** FETCH PRODUCTS **/
  fetchProducts = async () => {
    try {
      const res = await axios.get("/products");
      this.setState({ products: res.data.data || [] });
    } catch (error) {
      Swal.fire("Error", "Failed to load products", "error");
    }
  };

  /** PHONE SEARCH **/
  handlePhoneChange = (e) => {
    const value = e.target.value;

    const filtered = this.state.customers.filter(
      (c) =>
        c.phone?.toLowerCase().includes(value.toLowerCase()) ||
        c.full_name?.toLowerCase().includes(value.toLowerCase())
    );

    this.setState({
      customer_phone: value,
      filteredCustomers: filtered,
      showSuggestion: value.length > 0 && filtered.length > 0,
    });
  };

  handleNameChange = (e) => {
    this.setState({ customer_name: e.target.value });
  };

  handleEmailChange = (e) => {
    this.setState({ customer_email: e.target.value });
  };

  handleSelectSuggestion = (customer) => {
    this.setState({
      customer_phone: customer.phone,
      customer_name: customer.full_name,
      customer_email: customer.email || "",
      customer_id: customer.id,
      showSuggestion: false,
    });
  };

  hideSuggestion = () => setTimeout(() => this.setState({ showSuggestion: false }), 150);

  /** UPDATE FORM FIELDS **/
  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState(
      (prev) => ({
        formData: { ...prev.formData, [name]: value },
      }),
      this.calculateGrandTotal
    );
  };

  /** ADD PRODUCT RECORD **/
  addProduct = () => {
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        items: [
          ...prev.formData.items,
          { product_id: "", search_text: "", quantity: 1, price: 0, sub_total: 0 },
        ],
      },
    }));
  };

  /** REMOVE PRODUCT **/
  removeProduct = (index) => {
    const items = [...this.state.formData.items];
    items.splice(index, 1);

    this.setState(
      (prev) => ({ formData: { ...prev.formData, items } }),
      this.calculateGrandTotal
    );
  };

  /** SELECT PRODUCT **/
  handleProductSelect = (index, selected) => {
    if (!selected) return;

    const prod = this.state.products.find((p) => p.id === selected.value);
    const items = [...this.state.formData.items];

    items[index] = {
      ...items[index],
      product_id: prod.id,
      search_text: prod.product_name,
      price: Number(prod.sales_price),
      sub_total: Number(prod.sales_price) * items[index].quantity,
    };

    this.setState(
      (prev) => ({ formData: { ...prev.formData, items } }),
      this.calculateGrandTotal
    );
  };

  /** UPDATE QUANTITY/PRICE **/
  updateProduct = (index, field, value) => {
    const items = [...this.state.formData.items];

    if (field === "quantity") {
      const qty = Number(value) || 1;
      items[index].quantity = qty;
      items[index].sub_total = qty * items[index].price;
    } else if (field === "price") {
      const price = Number(value) || 0;
      items[index].price = price;
      items[index].sub_total = price * items[index].quantity;
    }

    this.setState(
      (prev) => ({ formData: { ...prev.formData, items } }),
      this.calculateGrandTotal
    );
  };

  /** CALCULATE TOTAL **/
  calculateGrandTotal = () => {
    const { formData } = this.state;

    const subtotal = formData.items.reduce((s, it) => s + Number(it.sub_total || 0), 0);

    const total =
      subtotal +
      Number(formData.delivery_charge || 0) -
      Number(formData.coupon_discount || 0) -
      Number(formData.discount || 0);

    this.setState({
      formData: { ...formData, grand_total: Number(total.toFixed(2)) },
    });
  };

  /** VALIDATE ORDER **/
  validate = () => {
    const errors = {};
    const { customer_phone, customer_name, formData } = this.state;

    if (!customer_phone) errors.customer_phone = "Phone required";
    if (!customer_name) errors.customer_name = "Name required";
    if (!formData.shipping_address) errors.shipping_address = "Shipping required";
    if (!formData.payment_type) errors.payment_type = "Payment required";

    formData.items.forEach((it, idx) => {
      if (!it.product_id) errors[`item_${idx}`] = "Select a product";
      if (!it.quantity || it.quantity <= 0) errors[`qty_${idx}`] = "Invalid quantity";
    });

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  /** SUBMIT ORDER **/
  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.validate()) {
      Swal.fire("Validation Error", "Please correct the highlighted fields.", "error");
      return;
    }

    const payload = {
      customer_phone: this.state.customer_phone,
      customer_name: this.state.customer_name,
      customer_email: this.state.customer_email || "",
      shipping_address: this.state.formData.shipping_address,
      division_name: this.state.formData.division_name,
      payment_type: this.state.formData.payment_type,
      order_status: this.state.formData.order_status,
      payment_status: this.state.formData.payment_status,
      order_note: this.state.formData.order_note,
      delivery_charge: Number(this.state.formData.delivery_charge),
      coupon_discount: Number(this.state.formData.coupon_discount),
      discount: Number(this.state.formData.discount),
      grand_total: Number(this.state.formData.grand_total),
      items: this.state.formData.items.map((it) => ({
        product_id: it.product_id,
        quantity: it.quantity,
        price: it.price,
        sub_total: it.sub_total,
      })),
    };

    try {
      const endpoint = this.isEditMode
        ? `/products/orders/${this.state.id}?_method=PUT`
        : `/products/orders`;

      const res = await axios.post(endpoint, payload);

      if (res.data.status === "success") {
        Swal.fire("Success", res.data.message, "success");
        this.props.router.navigate("/admin/orders");
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
    } catch (err) {
      Swal.fire("Error", "Failed to save order", "error");
    }
  };

  /** REACT SELECT STYLES **/
  reactSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (provided) => ({ ...provided, minHeight: "36px", height: "36px" }),
    indicatorsContainer: (provided) => ({ ...provided, height: "36px" }),
    valueContainer: (provided) => ({ ...provided, padding: "0 8px" }),
  };

  render() {
    const { products, formData, filteredCustomers, showSuggestion, errors } = this.state;
    const productOptions = products.map((p) => ({ value: p.id, label: `${p.product_name} — ৳${p.sales_price}` }));
    const subtotal = formData.items.reduce((s, it) => s + Number(it.sub_total || 0), 0);

    const compactCardBody = { padding: "12px" };
    const compactCard = "card shadow-sm border-0 rounded-4";

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row gx-3">
            <div className="col-lg-9">
              <div className={compactCard}>
                <div className="card-header d-flex justify-content-between align-items-center py-2 px-3">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Order</li>
                    <li className="breadcrumb-item">Form</li>
                  </ul>
                  <Link to="/admin/orders" className="btn btn-light-warning btn-sm">Order List</Link>
                </div>
                <div className="card-body" style={compactCardBody}>
                  <form onSubmit={this.handleSubmit}>
                    <div className="row g-2 mb-2">
                      <div className="col-md-6 position-relative">
                        <label className="form-label small mb-1">Customer Phone <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control form-control-sm ${errors.customer_phone ? "is-invalid" : ""}`}
                          placeholder="Search by phone or name…"
                          value={this.state.customer_phone}
                          onChange={this.handlePhoneChange}
                          onBlur={this.hideSuggestion}
                          onFocus={() => this.setState({ showSuggestion: true })}
                        />
                        {errors.customer_phone && <div className="text-danger small mt-1">{errors.customer_phone}</div>}
                        {showSuggestion && filteredCustomers.length > 0 && (
                          <div className="border rounded bg-white position-absolute w-100 shadow" style={{ zIndex: 1200, maxHeight: 180, overflowY: "auto" }}>
                            {filteredCustomers.map((c) => (
                              <div key={c.id} className="p-2 border-bottom small" style={{ cursor: "pointer" }} onClick={() => this.handleSelectSuggestion(c)}>
                                <strong>{c.phone}</strong> — {c.full_name}
                                {c.email && <div className="small text-muted">{c.email}</div>}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label small mb-1">Customer Name <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control form-control-sm ${errors.customer_name ? "is-invalid" : ""}`}
                          placeholder="Customer name"
                          value={this.state.customer_name}
                          onChange={this.handleNameChange}
                        />
                        {errors.customer_name && <div className="text-danger small mt-1">{errors.customer_name}</div>}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label small mb-1">Email</label>
                        <input
                          type="email"
                          className="form-control form-control-sm"
                          placeholder="Email (optional)"
                          value={this.state.customer_email || ""}
                          onChange={this.handleEmailChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label small mb-1">Payment Type <span className="text-danger">*</span></label>
                        <select
                          name="payment_type"
                          className={`form-control form-control-sm ${errors.payment_type ? "is-invalid" : ""}`}
                          value={formData.payment_type}
                          onChange={this.handleChange}
                        >
                          <option value="">Select Payment Type</option>
                          <option value="COD">Cash On Delivery</option>
                          <option value="Bkash">Bkash</option>
                          <option value="Nagad">Nagad</option>
                          <option value="Rocket">Rocket</option>
                          <option value="Bank Transfer">Bank Transfer</option>
                          <option value="Card Payment">Card Payment</option>
                          <option value="Others">Others</option>
                        </select>
                        {errors.payment_type && <div className="text-danger small mt-1">{errors.payment_type}</div>}
                      </div>

                    </div>

                    <div className="row g-2 mb-2">
                      <div className="col-12">
                        <label className="form-label small mb-1">Shipping Address <span className="text-danger">*</span></label>
                        <textarea
                          name="shipping_address"
                          className={`form-control form-control-sm ${errors.shipping_address ? "is-invalid" : ""}`}
                          rows="2"
                          value={formData.shipping_address}
                          onChange={this.handleChange}
                        />
                        {errors.shipping_address && <div className="text-danger small mt-1">{errors.shipping_address}</div>}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label small mb-1">Division</label>
                        <input
                          type="text"
                          name="division_name"
                          className="form-control form-control-sm"
                          value={formData.division_name}
                          onChange={this.handleChange}
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="form-label small mb-1">Order Status <span className="text-danger">*</span></label>
                        <select
                          name="order_status"
                          className={`form-control form-control-sm ${errors.order_status ? "is-invalid" : ""}`}
                          value={formData.order_status}
                          onChange={this.handleChange}
                        >
                          <option value="Pending">Pending</option>
                          <option value="Confirm">Confirm</option>
                          <option value="On Hold">On Hold</option>
                          <option value="Processing">Processing</option>
                          <option value="Shipped ">Shipped</option>
                          <option value="Courier">Courier</option>
                          <option value="Delivered">Delivered</option>
                          <option value="Cancelled">Cancelled</option>
                          <option value="Return">Return</option>
                          <option value="Refund">Refund</option>
                          <option value="Trash">Trash</option>
                        </select>
                        {errors.order_status && <div className="text-danger small mt-1">{errors.order_status}</div>}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label small mb-1">Payment Status <span className="text-danger">*</span></label>
                        <select
                          name="payment_status"
                          className={`form-control form-control-sm ${errors.payment_status ? "is-invalid" : ""}`}
                          value={formData.payment_status}
                          onChange={this.handleChange}
                        >
                          <option value="Unpaid">Unpaid</option>
                          <option value="Paid">Paid</option>
                        </select>
                        {errors.payment_status && <div className="text-danger small mt-1">{errors.payment_status}</div>}
                      </div>
                    </div>

                    <hr className="my-3" />
                    <div className="table-responsive mb-2" style={{ overflow: "visible" }}>
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th style={{ width: 250 }}>Product <span className="text-danger">*</span></th>
                            <th style={{ width: 100 }}>Qty</th>
                            <th style={{ width: 120 }}>Price</th>
                            <th style={{ width: 140 }}>Subtotal</th>
                            <th style={{ width: 100 }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.items.map((item, index) => (
                            <tr key={index}>
                              <td style={{ position: "relative", verticalAlign: "top" }}>
                                <Select
                                  menuPortalTarget={document.body}
                                  styles={this.reactSelectStyles}
                                  options={productOptions}
                                  onChange={(selected) => this.handleProductSelect(index, selected)}
                                  value={
                                    item.product_id
                                      ? { value: item.product_id, label: `${products.find((p) => p.id === item.product_id)?.product_name || item.search_text} — ৳${products.find((p) => p.id === item.product_id)?.sales_price}` }
                                      : item.search_text
                                        ? { value: null, label: item.search_text }
                                        : null
                                  }
                                  placeholder="Search product..."
                                  isClearable
                                  menuPlacement="auto"
                                />
                                {errors[`item_${index}`] && <div className="text-danger small mt-1">{errors[`item_${index}`]}</div>}
                              </td>

                              <td>
                                <input
                                  type="number"
                                  min="1"
                                  className={`form-control form-control-sm ${errors[`qty_${index}`] ? "is-invalid" : ""}`}
                                  value={item.quantity}
                                  onChange={(e) => this.updateProduct(index, "quantity", e.target.value)}
                                />
                                {errors[`qty_${index}`] && <div className="text-danger small mt-1">{errors[`qty_${index}`]}</div>}
                              </td>

                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={item.price}
                                  onChange={(e) => this.updateProduct(index, "price", e.target.value)}
                                />
                              </td>

                              <td>
                                <input
                                  type="number"
                                  className="form-control form-control-sm bg-light"
                                  readOnly
                                  value={item.sub_total}
                                />
                              </td>

                              <td className="text-center align-middle">
                                <div className="d-flex justify-content-center gap-1">
                                  <button type="button" className="btn btn-sm btn-light-danger" onClick={() => this.removeProduct(index)}>
                                    <i className="ph ph-trash"></i>
                                  </button>
                                  <button type="button" className="btn btn-sm btn-light-success" onClick={this.addProduct}>
                                    <i className="ph ph-plus"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}

                          <tr>
                            <td colSpan="2"></td>
                            <td>Subtotal</td>
                            <td>৳{subtotal.toFixed(2)}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="row mb-2">
                      <div className="col-12">
                        <label className="form-label small mb-1">Order Note</label>
                        <textarea name="order_note" className="form-control form-control-sm" rows="2" value={formData.order_note} onChange={this.handleChange}></textarea>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end gap-2">
                      <button type="reset" className="btn btn-light border btn-sm" onClick={() => window.location.reload()}>Clear</button>
                      <button type="submit" className="btn btn-primary btn-sm px-4">Submit Order</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <div className={compactCard} style={{ padding: 12 }}>
                <h6 className="fw-semibold text-uppercase text-muted mb-2">Order Summary</h6>

                <div className="d-flex justify-content-between mb-1 small">
                  <div>Subtotal</div>
                  <div>৳{subtotal.toFixed(2)}</div>
                </div>

                <div className="mb-2">
                  <label className="form-label small mb-1">Delivery Charge</label>
                  <input type="number" name="delivery_charge" className="form-control form-control-sm" value={formData.delivery_charge} onChange={this.handleChange} />
                </div>

                <div className="mb-2">
                  <label className="form-label small mb-1">Coupon Discount</label>
                  <input type="number" name="coupon_discount" className="form-control form-control-sm" value={formData.coupon_discount} onChange={this.handleChange} />
                </div>

                <div className="mb-2">
                  <label className="form-label small mb-1">Extra Discount</label>
                  <input type="number" name="discount" className="form-control form-control-sm" value={formData.discount} onChange={this.handleChange} />
                </div>

                <hr className="my-2" />

                <div className="d-flex justify-content-between fw-bold">
                  <div>Grand Total</div>
                  <div>৳{formData.grand_total}</div>
                </div>

                <div className="mt-2 text-muted small">
                  Tip: fill discounts or delivery charge to update the total.
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(OrderForm);
